module.exports = __webpack_public_path__ + "static/media/edit.61c742ef.svg";